function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 50.5,
  ry: 50.5,
  transform: "matrix(4.37114e-08 1 1 -4.37114e-08 55.5 55.5)",
  fill: "#E5E8F3"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("circle", {
  r: 40.4119,
  transform: "matrix(4.37114e-08 1 1 -4.37114e-08 55.4119 55.4119)",
  fill: "white"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44 58.3194C42.8954 58.3194 42 57.424 42 56.3194V54C42 52.8954 42.8954 52 44 52H67.9861C69.0907 52 69.9861 52.8954 69.9861 54V56.3194C69.9861 57.424 69.0907 58.3194 67.9861 58.3194H44Z",
  fill: "#535663"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 120.804,
  cy: 55.2882,
  r: 6.28821,
  fill: "#91C5D7"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 107.29,
  cy: 55.2882,
  r: 6.28821,
  transform: "rotate(90 107.29 55.2882)",
  fill: "#435CA1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 110.824,
  height: 110.824,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 7.5
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.505208 0 0 0 0 0.537068 0 0 0 0 0.625 0 0 0 1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgZoomOut = function SvgZoomOut(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 128,
    height: 111,
    viewBox: "0 0 128 111",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZoomOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom-out.94fb41b3.svg";
export { ForwardRef as ReactComponent };